<template>
  <input :style="[width?{width}:{}, center?{textAlign: 'center'}:{textAlign: 'start'}]" type="text" v-model.number="value" name="searchText" :placeholder="placeholder?placeholder:''">
</template>

<script>
export default {
  props: ['defaultValue', 'placeholder', 'width', 'center'],
  data () {
    return {
      value: null
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      console.log(isNaN(parseInt(this.value)), this.value, 'isNaN(parseInt(this.value))')
      if (isNaN(parseInt(this.value))) {
        this.value = 0
      } else {
        this.value = parseInt(this.value)
      }
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@media screen and (orientation: landscape) {
  div {
    position: relative;
    height: 40px;
    align-items: center;
    justify-content: flex-start;
    display: inline-flex;
    margin-block: auto;
  }
  input[type=text] {
    border-radius: 3px;
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    height: 40px;
    padding-inline: 1em;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.1em;
    &::placeholder {
      color: #CACACA;
    }
  }
}
</style>
